const module = { name: 'news/movieNews/latestNewsWall', exports: {} }; const exports = module.exports;



import { fd_url_manager as link } from 'require-core';



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    ITEM: '.content-item-container',
    WALL: '.content-item-list.wall',
}


let $container


let $moreBtn
function onFetchDone(data) {
    if (data.done) {
        return $moreBtn.hide();
    }
    const $items = $(Selectors.ITEM, data.markup);
    $items
        .addClass('hide-item')
        .appendTo($container)
        .imagesLoaded(() => {
        $container.isotope('appended', $items);
        $items.removeClass('hide-item');
        focusFirstNewItem($container[0]?.children, $items, Selectors.ITEM + ' a');
        $moreBtn
            .text($moreBtn.data('text-state-default')).removeAttr('disabled')
            .data('next-page', data.nextPage);
    });
}
function focusFirstNewItem(allData, newData, className) {
    if (allData?.length && newData?.length) {
        const focusElement = document.querySelectorAll(className)[allData.length - newData.length];
        if (focusElement) {
            focusElement.focus({ focusVisible: true, preventScroll: false });
        }
    }
}
function onFetchFail() {
    $moreBtn.hide();
}
function onMoreBtnClicked() {
    $moreBtn = $(this);
    $moreBtn.text($moreBtn.data('text-state-loading')).attr('disabled', 'disabled');
    xhr.ajax({
        method: 'GET',
        url: link.napiMovieNewsPager({
            page: $moreBtn.data('next-page')
        }),
    })
        .done(onFetchDone)
        .fail(onFetchFail);
}
function init() {
    $container = $(Selectors.WALL);
    $container.imagesLoaded(() => {
        $container.isotope();
        $(window).on('resize', $.debounce(250, () => $container.isotope()));
    });
    $('#latestNewsWall').find('.more-btn').on('click', onMoreBtnClicked);
}
module.exports = {
    init
};
export default module.exports;